import { createStore, StateMachineProvider } from 'little-state-machine';
import { ReactNode } from 'react';
import LeadListCreateView from './LeadListCreate';
import { LeadListCreateThemeProvider } from './LeadListCreateThemeProvider';

createStore({
  leadListCreate: {},
});

const StateMachineProviderTyped = StateMachineProvider as unknown as React.FC<{
  children: ReactNode;
}>;

const LeadListCreateViewWrapper = () => (
  <LeadListCreateThemeProvider>
    <StateMachineProviderTyped>
      <LeadListCreateView />
    </StateMachineProviderTyped>
  </LeadListCreateThemeProvider>
);

export default LeadListCreateViewWrapper;
